//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "FaqNoQuestions",
    computed: {
        text() {
            const {from, to} = (AppConfig?.mainInfo?.supportTime ?? {});
            return this.$t('static.faq.noQuestion.subtitle', {from, to});
        },
        contacts() {
            const {phone, mail} = (AppConfig?.mainInfo?.contacts ?? {});
            const formattedPhone = (AppConfig?.formatPhoneRegexp ?? (str => str))(phone);
            return [
                {text: this.$t('static.faq.noQuestion.phone')},
                {text: this.$t('static.faq.noQuestion.email')},
                {text: this.$t('static.faq.noQuestion.message')}
            ]
        }
    }
}
